export enum WeatherTrafficPageId {
    weatherPageId = 'weather-camera',
    trafficPageId = 'traffic-camera'
}

export enum WeatherTrafficRoutePaths {
    weatherRoutePath = '/weather-camera/',
    trafficRoutePath = '/traffic-cam/'
}